import React, { useCallback } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  STUDENTS_ASSIGNMENTS_LIST_URL,
  TEACHERS_SUBSCRIPTIONS_DASHBOARD_URL
} from 'config/urls';

import { colors } from 'theme/palette';
import { useMenu } from 'utils/hooks';

import Typography from 'components/Typography';

import { ReactComponent as AccountIcon } from './assets/account.svg';
import { ReactComponent as SignOutIcon } from './assets/sign-out.svg';
import styles from './styles.module.css';

const AccountMenuButton = ({ history, user, usage, logout }) => {
  const [anchorEl, openMenu, closeMenu] = useMenu();

  const redirectToSubscriptionsDashboard = useCallback(() => {
    history.push(TEACHERS_SUBSCRIPTIONS_DASHBOARD_URL);
    closeMenu();
  }, [closeMenu, history]);

  const openStudentApp = () =>
    window.open(STUDENTS_ASSIGNMENTS_LIST_URL, '_blank');

  return (
    <>
      <IconButton onClick={openMenu} className={styles.iconButton}>
        <AccountIcon />
      </IconButton>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        getContentAnchorEl={null}
        open={Boolean(anchorEl)}
        autoFocus={false}
        classes={{ list: styles.menuList, paper: styles.menuPaper }}
        onClose={closeMenu}
      >
        <MenuItem button={false}>
          <Typography variant="S-TEXT-1" color={colors.blue2}>
            {user.name}
          </Typography>
        </MenuItem>
        {usage && (
          <MenuItem onClick={redirectToSubscriptionsDashboard}>
            <Typography variant="S-TEXT-1" color={colors.blue2}>
              Account
            </Typography>
          </MenuItem>
        )}
        <MenuItem onClick={logout}>
          <Typography variant="S-TEXT-1" color={colors.blue2}>
            Sign out
          </Typography>
        </MenuItem>
        {user.is_teacher && user.student_id && (
          <MenuItem onClick={openStudentApp}>
            <div className={styles.studentLink}>
              <Typography variant="S-TEXT-1" color={colors.blue2}>
                Student App
              </Typography>
              <SignOutIcon />
            </div>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};

export default AccountMenuButton;
